import { render, staticRenderFns } from "./ModalErrosCarga.vue?vue&type=template&id=7fdcdcb1&scoped=true"
import script from "./ModalErrosCarga.vue?vue&type=script&lang=ts"
export * from "./ModalErrosCarga.vue?vue&type=script&lang=ts"
import style0 from "./ModalErrosCarga.vue?vue&type=style&index=0&id=7fdcdcb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdcdcb1",
  null
  
)

export default component.exports